// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.display-column {
  display: flex;
  flex-wrap: wrap;
}

.package-tile {
  background: white;
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  float: left;
  margin: 0 15px 30px;
  padding-bottom: 86px;
  position: relative;
  width: calc(33.33% - 30px);
}
.package-tile .package-title {
  font-weight: bold;
  padding: 20px 15px 0;
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 16px;
}
.package-tile .package-price {
  font-size: 68px;
  line-height: 1;
  margin-bottom: 0;
}
.package-tile .package-price .price-symbol {
  font-size: 3rem;
  vertical-align: top;
}
.package-tile .box-section {
  background: #191919;
  color: white;
  font-family: Omnes-ATT-W02-Italic;
  font-size: 18px;
  padding: 20px;
}
.package-tile .package-description {
  padding: 18px 20px 30px;
}
.package-tile .package-description p:empty {
  margin-bottom: 0;
}
.package-tile footer {
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  border-radius: 0 0 8px 8px;
  background: white;
  border-top: 1px solid #d2d2d2;
  bottom: 0;
  height: 86px;
  padding: 20px;
  position: absolute;
  text-align: center;
  width: 100%;
}

.product-badge {
  background: #191919;
  border-radius: 6px 6px 0 0;
  bottom: 100%;
  color: #71c5e8;
  display: block;
  font-family: "Omnes-ATT-W02-Medium";
  height: 22px;
  line-height: 1.4;
  position: absolute;
  text-align: center;
  width: 100%;
}
.product-badge:empty {
  background-color: transparent;
  border-color: transparent;
}

@media (max-width: 1024px) {
  .display-column {
    display: block;
  }
  .package-tile {
    float: none;
    margin: auto auto 20px;
    max-width: 420px;
    padding-bottom: 66px;
    width: 100%;
  }
  .package-tile .per-month {
    font-size: 18px;
  }
  .package-tile .package-title {
    font-size: 18px;
  }
  .package-tile .package-description {
    padding: 8px 20px 20px;
  }
  .package-tile footer {
    border-top: 0;
    height: 66px;
    padding: 0 20px;
    position: absolute;
    text-align: center;
    width: 100%;
  }
  .package-tile .btn-change {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/subscription-card/subscription-card.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA9IA;EACE,aAAA;EACA,eAAA;AAgJF;;AA7IA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;AAgJF;AA9IE;EACE,iBAAA;EACA,oBAAA;EACA,mCAAA;EACA,eAAA;AAgJJ;AA7IE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AA+IJ;AA7II;EACE,eAAA;EACA,mBAAA;AA+IN;AA3IE;EACE,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;AA6IJ;AA1IE;EACE,uBAAA;AA4IJ;AA1II;EACE,gBAAA;AA4IN;AAxIE;EFlBE,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEoBA,iBAAA;EACA,6BAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA8IJ;;AA1IA;EACE,mBAAA;EACA,0BAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA6IF;AA3IE;EACE,6BAAA;EACA,yBAAA;AA6IJ;;AFvMI;EE+DF;IACE,cAAA;EA4IF;EAzIA;IACE,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,oBAAA;IACA,WAAA;EA2IF;EAzIE;IACE,eAAA;EA2IJ;EAxIE;IACE,eAAA;EA0IJ;EAvIE;IACE,sBAAA;EAyIJ;EAtIE;IACE,aAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,kBAAA;IACA,WAAA;EAwIJ;EArIE;IACE,WAAA;EAuIJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n// product details page title component css\n\n\n.display-column {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.package-tile {\n  background: color(default, light);\n  border: 1px solid color(default, dark);\n  border-radius: 5px;\n  float: left;\n  margin: 0 15px 30px;\n  padding-bottom: 86px;\n  position: relative;\n  width: calc(33.33% - 30px);\n\n  .package-title {\n    font-weight: bold;\n    padding: 20px 15px 0;\n    font-family: 'Omnes-ATT-W02', Arial;\n    font-size: 16px;\n  }\n\n  .package-price {\n    font-size: 68px;\n    line-height: 1;\n    margin-bottom: 0;\n\n    .price-symbol {\n      font-size: 3rem;\n      vertical-align: top;\n    }\n  }\n\n  .box-section {\n    background: color(inverse, darker);\n    color: color(default, light);\n    font-family: Omnes-ATT-W02-Italic;\n    font-size: 18px;\n    padding: 20px;\n  }\n\n  .package-description {\n    padding: 18px 20px 30px;\n\n    p:empty {\n      margin-bottom: 0;\n    }\n  }\n\n  footer {\n    @include vendor-prefix('border-radius', 0 0 8px 8px);\n    background: color(default, light);\n    border-top: 1px solid color(default, dark);\n    bottom: 0;\n    height: 86px;\n    padding: 20px;\n    position: absolute;\n    text-align: center;\n    width: 100%;\n  }\n}\n\n.product-badge {\n  background: color(inverse, darker);\n  border-radius: 6px 6px 0 0;\n  bottom: 100%;\n  color: #71c5e8;\n  display: block;\n  font-family: 'Omnes-ATT-W02-Medium';\n  height: 22px;\n  line-height: 1.4;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n\n  &:empty {\n    background-color: transparent;\n    border-color: transparent;\n  }\n}\n\n@include respond-to (small) {\n  .display-column {\n    display: block;\n  }\n\n  .package-tile {\n    float: none;\n    margin: auto auto 20px;\n    max-width: 420px;\n    padding-bottom: 66px;\n    width: 100%;\n\n    .per-month {\n      font-size: 18px;\n    }\n\n    .package-title {\n      font-size: 18px;\n    }\n\n    .package-description {\n      padding: 8px 20px 20px;\n    }\n\n    footer {\n      border-top: 0;\n      height: 66px;\n      padding: 0 20px;\n      position: absolute;\n      text-align: center;\n      width: 100%;\n    }\n\n    .btn-change {\n      width: 100%;\n    }\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
